<!--
 * @Author: 朱占伟
 * @LastEditors: 朱占伟
 * @description: 选择交付类型
 * @Date: 2021-09-14 14:36:56
 * @LastEditTime: 2021-09-16 14:46:56
-->

<template>
  <div class="DeliveryType">
    <van-cell is-link :title="config.name" value-class="flex align-center justify-end" @click="openBox">
      <template #value>
        <span class="store-name ml-10">{{ selectdStoreName }}</span>
      </template>
    </van-cell>
    <van-action-sheet v-model:show="state.show" :title="config.title" @select="openBox">
      <div v-for="item in state.stores" :key="item.value" :class="{selected:item.value === state.selectdStore}" class="flex justify-center align-center pt-10 pb-10 border-bottom" @click="onSelect(item.value)">
        <span class="ml-10">{{ item.name || '--' }}</span>
      </div>
    </van-action-sheet>
  </div>
</template>

<script>
import {reactive , inject , computed} from "vue"
import {serviceTrack} from 'model/common'
import {useStore} from 'vuex'
export default {
  name:'DeliveryType',
  props:{
    val:{
      type:String,
      default:()=>'24h'
    },
    config:{
      type:Object,
      default:()=>{
        return {
          title:'Delivery Type',
          name:'Delivery Type'
        }
      }
    }

  },
  setup(props,{emit}){
    const store=useStore()
    //交互类型
    const deliveryTypeArray = [
      {
        value: '24h',
        src: null,
        alt: null,
        name: 'Spread Installs Within 24h'
      },
      {
        value: 'once',
        src: null,
        alt: null,
        name: 'All Installs At Once'
      }
    ]

    const common = inject("$common")
    const state = reactive({
      selectdStore : props.val || '24h',
      show: false,
      stores:common.deliveryTypeArray || deliveryTypeArray
    })

    //打开选项框
    const openBox = ()=>{
      state.show = !state.show
    }
 
    //选择应用的名称
    const selectdStoreName = computed(()=>{
      let tem = null
      state.stores && state.stores.forEach((item)=>{
        if(item.value === state.selectdStore){
          tem = item.name
          return
        }
      })
      return tem
    })
  
    //选择结果
    const onSelect = (val = null)=>{
      openBox()
      state.selectdStore = val
      //暴露值
      emit('select',val)
      serviceTrack(val === '24h' ? 'delivery_24h' : 'delivery_at_once',store)
    }


    return {
      state,openBox,selectdStoreName,
      onSelect
    }
  }
}

</script>
<style lang="scss" scoped>

.store-name {
  font-size: $fontText;
  color: $fontColor;
}

.DeliveryType {
  &:deep(.van-cell__title, .van-cell__value) {
    flex: auto;
  }

  &:deep(.van-action-sheet__header) {
    font-weight: bold;
    margin: 0 10px;
    border-bottom: 1px solid $border;
  }

  &:deep(.van-action-sheet__content) {
    padding: 0 10px;
    margin-bottom: 30px;
  }

  &:deep(.van-cell__title) {
    font-weight: bold;
    color: $fontColor;
  }

  &:deep(.van-cell__value) {
    overflow: unset;
    white-space: nowrap;
    font-size: $fontText;
  }

  &:deep(.van-tab__text--ellipsis) {
    line-clamp: initial;
    -webkit-line-clamp: initial;
  }

  &:deep(.van-action-sheet) {
    z-index: 10003 !important;
  }
}

</style>